/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_CityInputs */

const th_event_city = /** @type {(inputs: Event_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เมือง`)
};

const en_event_city = /** @type {(inputs: Event_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`City`)
};

const ja_event_city = /** @type {(inputs: Event_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`都市`)
};

const zh_event_city = /** @type {(inputs: Event_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`城市`)
};

const es_event_city = /** @type {(inputs: Event_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ciudad`)
};

const pt_event_city = /** @type {(inputs: Event_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cidade`)
};

const id_event_city = /** @type {(inputs: Event_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kota`)
};

const fr_event_city = /** @type {(inputs: Event_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ville`)
};

const tl_event_city = /** @type {(inputs: Event_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lungsod`)
};

const vi_event_city = /** @type {(inputs: Event_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thành phố`)
};

const ko_event_city = /** @type {(inputs: Event_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`도시`)
};

const de_event_city = /** @type {(inputs: Event_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stadt`)
};

const ru_event_city = /** @type {(inputs: Event_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Город`)
};

const tr_event_city = /** @type {(inputs: Event_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şehir`)
};

const it_event_city = /** @type {(inputs: Event_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Città`)
};

const pl_event_city = /** @type {(inputs: Event_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miasto`)
};

const uk_event_city = /** @type {(inputs: Event_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Місто`)
};

const hi_event_city = /** @type {(inputs: Event_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शहर`)
};

const ar_event_city = /** @type {(inputs: Event_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المدينة`)
};

const ms_event_city = /** @type {(inputs: Event_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bandar`)
};

const bn_event_city = /** @type {(inputs: Event_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`শহর`)
};

const zh_tw2_event_city = /** @type {(inputs: Event_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`城市`)
};

const zh_hk2_event_city = /** @type {(inputs: Event_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`城市`)
};

const ur_event_city = /** @type {(inputs: Event_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شہر`)
};

const fa_event_city = /** @type {(inputs: Event_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شهر`)
};

const sw_event_city = /** @type {(inputs: Event_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mji`)
};

const nl_event_city = /** @type {(inputs: Event_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stad`)
};

/**
* | output |
* | --- |
* | "City" |
*
* @param {Event_CityInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const event_city = /** @type {((inputs?: Event_CityInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_CityInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_event_city(inputs)
	if (locale === "ja") return ja_event_city(inputs)
	if (locale === "zh") return zh_event_city(inputs)
	if (locale === "es") return es_event_city(inputs)
	if (locale === "pt") return pt_event_city(inputs)
	if (locale === "id") return id_event_city(inputs)
	if (locale === "fr") return fr_event_city(inputs)
	if (locale === "tl") return tl_event_city(inputs)
	if (locale === "vi") return vi_event_city(inputs)
	if (locale === "ko") return ko_event_city(inputs)
	if (locale === "de") return de_event_city(inputs)
	if (locale === "ru") return ru_event_city(inputs)
	if (locale === "tr") return tr_event_city(inputs)
	if (locale === "it") return it_event_city(inputs)
	if (locale === "pl") return pl_event_city(inputs)
	if (locale === "uk") return uk_event_city(inputs)
	if (locale === "hi") return hi_event_city(inputs)
	if (locale === "ar") return ar_event_city(inputs)
	if (locale === "ms") return ms_event_city(inputs)
	if (locale === "bn") return bn_event_city(inputs)
	if (locale === "zh-TW") return zh_tw2_event_city(inputs)
	if (locale === "zh-HK") return zh_hk2_event_city(inputs)
	if (locale === "ur") return ur_event_city(inputs)
	if (locale === "fa") return fa_event_city(inputs)
	if (locale === "sw") return sw_event_city(inputs)
	if (locale === "nl") return nl_event_city(inputs)
	return en_event_city(inputs)
});